import script from "./LoadingSpinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=0a2e2446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2e2446"]])

export default __exports__